import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  CreateButton,
  Datagrid,
  EditButton,
  List,
  ListActions,
  ShowButton,
  SimpleList,
  TextField,
  Title,
  useStore,
} from "react-admin";
import { checkPermission } from "server/security/utils";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import CustomFilter from "features/CustomFilter";
import useInternshipFilter from "features/filters/useInternshipFilter";
import SecuredComponent from "server/security/SecuredComponent";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { MOBILE_BREAKPOINT } from "utils/constants";

const STORE_KEY = "internshipCyclesSchedule.filters";

const ListScheduleCycleStream = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [filters, setFilters] = useStore(STORE_KEY, null);
  const internship = useInternshipFilter({ filters, withPlan: true });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };
  return (
    <>
      {!filters && <Title title={"Потоци за преддипломен стаж"} />}
      <CustomFilter
        title="Избери филтри"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={internship.fields}
        buttonLabel="Покажи"
        buttonDisabled={!internship.isComplete}
        buttonOnClick={() => handleSearch(internship.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за поток за преддипломен стаж или създай нов
            </Typography>
            <SecuredComponent permission={permissions.canManageInternshipSchedules}>
              <CreateButton />
            </SecuredComponent>
          </Box>
        </Paper>
      ) : (
        <List
          exporter={false}
          title="Потоци за преддипломен стаж"
          filter={filters}
          actions={
            <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageInternshipSchedules)} />
          }
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={record => <MobileListRow fields={[{ label: "Име", value: record?.name }]} />}
              tertiaryText={() => (
                <>
                  <SecuredComponent permission={permissions.canPreviewInternshipSchedules}>
                    <ShowButton label="" />
                  </SecuredComponent>
                  <SecuredComponent permission={permissions.canManageInternshipSchedules}>
                    <EditButton label="" />
                  </SecuredComponent>
                </>
              )}
            />
          ) : (
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
              sx={{
                "& .RaDatagrid-headerCell": {
                  textAlign: "left",
                },
              }}
            >
              <TextField
                source="name"
                label="Име"
                sortable={false}
              />
              <SecuredComponent permission={permissions.canPreviewInternshipSchedules}>
                <ShowButton />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canManageInternshipSchedules}>
                <EditButton />
              </SecuredComponent>
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListScheduleCycleStream;
